import {
  enableProdMode,
  ErrorHandler,
  APP_INITIALIZER,
  LOCALE_ID,
  importProvidersFrom,
} from '@angular/core';

import { environment } from './environments/environment';
import './app/shared/utils/userSelect';
import { GlobalErrorHandler } from './app/global-error-handler';
import { Store, StoreModule } from '@ngrx/store';
import { setCurrentPlatformData } from './app/data/store/actions/platform.actions';
import { getPlatformFromViewport } from './app/shared/utils/platform.utils';
import { UtilsService } from './app/shared/services/utils.service';
import { HttpClientModule } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { AddBaseUrlPipe } from './app/shared/pipe/add-baseUrl/add-base-url.pipe';
import { GetImagePreviewPipe } from './app/shared/pipe/get-image-preview/get-image-preview.pipe';
import { GetFilePicturePipe } from './app/shared/pipe/get-file-picture/get-file-picture.pipe';
import { ICONS_PATH } from './app/shared/components/icon/icons-path';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { SharedModule } from './app/shared/shared.module';
import { reducers, metaReducers, effects } from './app/data/store/reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { provideServiceWorker } from '@angular/service-worker';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      IonicModule,
      AppRoutingModule,
      HttpClientModule,
      SharedModule,
      StoreModule.forRoot(reducers, {
        metaReducers,
      }),
      StoreDevtoolsModule.instrument({
        maxAge: 25,
        logOnly: environment.production,
      }),
      EffectsModule.forRoot(effects),
      ReactiveFormsModule,
      StoreRouterConnectingModule.forRoot(),
    ),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (_store: Store) => {
        return () => {
          _store.dispatch(setCurrentPlatformData({ platform: getPlatformFromViewport() }));
        };
      },
      multi: true,
      deps: [Store, UtilsService],
    },
    HttpClientModule,
    { provide: LOCALE_ID, useValue: 'ru' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AddBaseUrlPipe,
    GetImagePreviewPipe,
    GetFilePicturePipe,
    {
      provide: ICONS_PATH,
      useValue: 'assets/images/icons-svg',
    },
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      updateViaCache: 'none',
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}).catch((err) => console.error(err));
